export function boardLocal() {
    const data = localStorage.getItem('board');
    if (!data || data === 'undefined' || data === undefined) return null;
    try {
        return JSON.parse(data);
    } catch (e) {
        console.error('Error parsing JSON from localStorage (board):', e);
        return null;
    }
}

export function columnsLocal() {
    const data = localStorage.getItem('columns');
    if (!data || data === 'undefined' || data === undefined) return null;
    try {
        return JSON.parse(data);
    } catch (e) {
        console.error('Error parsing JSON from localStorage (columns):', e);
        return null;
    }
}

export function tasksLocal() {
    const data = localStorage.getItem('tasks');
    if (!data || data === 'undefined' || data === undefined) return null;
    try {
        return JSON.parse(data);
    } catch (e) {
        console.error('Error parsing JSON from localStorage (tasks):', e);
        return null;
    }
}

export function userDataLocal() {
    const data = localStorage.getItem('userData');
    if (!data || data === 'undefined' || data === undefined) return null;
    try {
        return JSON.parse(data);
    } catch (e) {
        console.error('Error parsing JSON from localStorage (userData):', e);
        return null;
    }
}
